import ExtendableError from 'es6-error';

export default class UnauthorizedHttpError extends ExtendableError {
    constructor(message = 'Unauthorized.') {
        super(message);
    }
}
